import React from 'react';
import PropTypes from 'prop-types';

import styles from './infoBox.module.css';

const InfoBox = ({ title, children }) => (
  <div className={styles.infoBox}>
    {title && <div className={styles.title}>{title}</div>}
    {children}
  </div>
);

InfoBox.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element.isRequired
};

InfoBox.defaultProps = {
  title: undefined
};

export default InfoBox;
